import axios from './HTTP'

export default {
  login (params, callback, errorCallback) {
    axios
      .post(`/api/user_token.json`, {
        auth: {
          email: params.username.toLowerCase(),
          password: params.password
        }
      })
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  loginAndBecome (params, callback, errorCallback) {
    axios
      .post(`/api/user_token.json`, {
        become: params.becomeEmail,
        auth: {
          email: params.username.toLowerCase(),
          password: params.password
        }
      })
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  requestPasswordReset (email, callback, errorCallback) {
    axios
      .post('/api/password_resets', {
        password_reset: {
          email: email.toLowerCase()
        }
      })
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
    })
  },

  resetPassword (params, callback, errorCallback) {
    axios
      .patch(`/api/password_resets/${ params.token }`, {
        password_reset: {
          password: params.password,
          password_confirmation: params.password_confirmation,
        }
      })
      .then(response => {
        callback(response.data)
      })
    .catch(error => {
      errorCallback(error)
    })
  },

  pinLogin (params, callback, errorCallback) {
    axios
      .post(`/api/user_pin_token.json`, {
        auth: {
          username: params.username,
          pin: params.pin
        }
      })
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  setHeader (token) {
    axios.defaults.headers.common['Authorization'] = token
  },

  removeHeader (token) {
    delete axios.defaults.headers.common['Authorization']
  },
}
